import { render } from "./sounds-varanasi.vue?vue&type=template&id=4c8db6bc&scoped=true"
import script from "./sounds-varanasi.vue?vue&type=script&lang=js"
export * from "./sounds-varanasi.vue?vue&type=script&lang=js"

import "./sounds-varanasi.vue?vue&type=style&index=0&id=4c8db6bc&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8db6bc"]])

export default __exports__